import { ArrowRight } from 'lucide-react'
import { type FC, useMemo } from 'react'

import type { ResPrice } from '@/lib/queries/business/pricing/types'

export interface EnterprisePlanProps {
  pricing?: ResPrice[]
}

export const EnterprisePlan: FC<EnterprisePlanProps> = ({ pricing }) => {
  const maxCases = useMemo(() => {
    return pricing?.reduce((acc, x) => Math.max(acc, x.max_cases), 0)
  }, [pricing])

  return (
    <div className="flex animate-fade-in flex-col items-center justify-center gap-[14px] px-5 pb-20 text-center text-white duration-150">
      <div className="text-xl font-bold">Enterprise</div>
      <div className="font-[500]">
        {!!maxCases && (
          <div className="flex justify-center gap-2.5">
            <span>•</span>
            <span className="">More than {new Intl.NumberFormat('en-US').format(maxCases)} cases</span>
          </div>
        )}
        <div className="flex justify-center gap-2.5">
          <span>•</span>
          <span>All premium features + dedicated customer success rep</span>
        </div>
      </div>
      <a className="ml-5" href="mailto:contact@lawfully.com" aria-label="Contact Lawfully Support">
        <div className="flex items-end gap-1">
          <div className="text-xl font-medium underline underline-offset-4">Talk to the team</div>
          <ArrowRight />
        </div>
      </a>
    </div>
  )
}
